export enum SearchReportType {
  // eslint-disable-next-line no-unused-vars
  Report = 0,
  // eslint-disable-next-line no-unused-vars
  SearchResults = 1,
}
